import { createReducer } from 'typesafe-actions';

import { AlertActionTypes, TAlertState, TAlertAction, AlertsKeys } from '../types/alert.types';

const initialState: TAlertState = AlertsKeys.reduce((prev, current) => {
  return {
    ...prev,
    [current]: {
      isDisplayed: false,
      isValidated: false,
    },
  };
}, {}) as TAlertState;

export const alertReducer = createReducer<TAlertState, TAlertAction>(initialState)
  .handleType(AlertActionTypes.OPEN_ALERT, (state, action) => {
    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        isDisplayed: true,
      },
    };
  })

  .handleType(AlertActionTypes.CLOSE_ALERT, (state, action) => {
    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        isDisplayed: false,
      },
    };
  })
  .handleType(AlertActionTypes.VALIDATE_ACTION, (state, action) => {
    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        isValidated: true,
      },
    };
  });
